var transactionMap_ = new Array();
var emptyTransaction_ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0];
var BKG_COL = 0;
var STT_COL = 1;
var TXN_COL = 2;
var SVC_TAX_COL = 3;
var EDU_CESS_COL = 4;
var H_EDU_CESS_COL = 5;
var STAMP_DUTY_COL = 6;
var SEBI_FEES_COL = 7;
var BUY_TURNOVER_COL = 8;
var SELL_TURNOVER_COL = 9;
var CURR_TURNOVER_COL = 10;
var MTM_COL = 11;
var STRIKE_PX_COL = 12;
var CONTRACT_UNIT_SIZE_COL = 14;
var CLR_CHG_COL = 15;
var totalTransactionCharges_ = clone(emptyTransaction_);
transactionMap_ = new Array();
transactionMap_[-1] = clone(emptyTransaction_);
var totalTurnover_ = parseFloat("0");
var arraySize_ = 0;
var STT_INTRADAY = 0.00025;
var STT_DELIVERY = 0.001;
var STT_FUTURES = 0.0002;
var STT_OPTIONS = 0.001;
var CTT_INTRADAY = 0.0001;
var CTT_DELIVERY = 0;
var TURNOVER_NSE_EQ = 0.0000345;
var TURNOVER_BSE_EQ = 0.0000345;
var TURNOVER_MCX_FUT = 0.000026;
var TURNOVER_NSE_FUT = 0.00002;
var TURNOVER_NSE_OPT =  0.00053;
var TURNOVER_NSE_CURR_FUT =  0.000009; //0.0000150; 
var TURNOVER_NSE_CURR_OPT =  0.00035; //0.0006000;
var TURNOVER_BSE_CURR_FUT =  0.0000022; //0.0000050;
var TURNOVER_BSE_CURR_OPT =  0.00001; //0.0002510;
var SVC_TAX_RATE = 0.18;
var EDU_CESS_RATE = 0;
var HIGHER_EDU_CESS_RATE = 0;
var DP_CHARGES = 0;
var Penny_Brokerage = 0.25;
var PennyBrokerageFinal = '';
var STAMP_DUTY_RATES = /** @dict */ {
	'MH': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'WB': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'DEFAULT': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002], // same as STAMP_DUTY_RATES.MH
	'DL': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'KL': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'GJ': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'RJ': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'TN': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'KT': [0.00003, 0.00015, 0.00002, 0.00003, 0.000001, 0.00002],
	'NRI': [0, 0.0001, 0.00002, 0, 0, 0]
}
var SELECTED_STAMP_DUTY_RATE = STAMP_DUTY_RATES['MH'];
var STAMP_DUTY_EQ_INTR_INDEX = 0;
var STAMP_DUTY_EQ_DEL_INDEX = 1;
var STAMP_DUTY_FUT_INDEX = 2;
var STAMP_DUTY_OPT_INDEX = 3;
var STAMP_DUTY_CDS_INDEX = 4;
var STAMP_DUTY_COMMO_INDEX = 5; 

var STAMP_DUTY_COMMO_INDEX_OPT = 0.00003

var SEBI_RATE = 0.000001;
var LAKH = 100000;
var CRORE = 10000000;

var BKG_FUT_NRI = 0.001;
var MAX_BROKERAGE = 20;
var MAX_BROKERAGE_NRI = 200;

var MAX_EXCH_BKG = 0.025;
var BKG_INTRADAY = 0.0001;
var BKG_DELIVERY = 0.025;
var IMG_ROW = 6;
var MAX_TABLE_LENGTH = 15;
var PRODUCT_EQ = "EQ";
var PRODUCT_F = "FUT";
var PRODUCT_O = "OPT";
var EXCHANGE_BSE = "BSE";
var EXCHANGE_NSE = "NSE";
var EXCHANGE_NSECDS = "NCD";
var EXCHANGE_BSECDS = "BCD";
var EXCHANGE_MCX = "MCX";
var PLAN_ENUM = { UPSTOX: 0, NRI: 1 };
var currentPlan = PLAN_ENUM.UPSTOX;
var isNRI = false;
var intraday = true;

// Google Closure Compiler tags
// add all public functions here
window['addBox'] = addBox;
window['extractNumber'] = extractNumber;
window['updateCharges'] = updateCharges;
// window['addRowIfEnter'] = addRowIfEnter;
window['removeBox'] = removeBox;
window['blockNonNumbers'] = blockNonNumbers;
// window['populateExchange'] = populateExchange;
// window['populateProduct'] = populateProduct;
// window['populateSymbols'] = populateSymbols;
window['changeTIF'] = changeTIF;
window['changeStateStampDuty'] = changeStateStampDuty;
window['triggerInstrumentChanged'] = triggerInstrumentChanged;
window['setNRI'] = setNRI;
window.result = {
	exchangeToken: '12341234'
}

Number.prototype.roundTo = function(num) {
    var resto = this%num;
    var x;
    if (resto <= (num/2)) {
        x = this-resto;
    } else {
        x = this+num-resto;
    }
    if(x <= 0)
    	x = num;
    return x;
}

function setNRI(_isNRI)
{
	isNRI = _isNRI;
	//var id = -1;

	intraday = false;

	SELECTED_STAMP_DUTY_RATE = STAMP_DUTY_RATES['NRI'];
	MAX_BROKERAGE = MAX_BROKERAGE_NRI;
	currentPlan = PLAN_ENUM.NRI;
}

function changeStateStampDuty(state)
{
	if(STAMP_DUTY_RATES[jQuery("#bState").val()] != undefined)
	{
		SELECTED_STAMP_DUTY_RATE = STAMP_DUTY_RATES[jQuery("#bState").val()];
		jQuery("#stampDutyDiv").show();
		jQuery("#stampDutyVariesDiv").hide();
	}
	else
	{
		SELECTED_STAMP_DUTY_RATE = STAMP_DUTY_RATES['DEFAULT'];

		jQuery("#stampDutyDiv").hide();
		jQuery("#stampDutyVariesDiv").show();
	}
	var key, n = Object.keys(transactionMap_).length;
	for(key=0; key < n; ++key)
	{
		updateChargesById(false, Object.keys(transactionMap_)[key]);
	}
}

function changeTIF(value, elem)
{
	intraday = value;
	var id = "-" +(jQuery(elem).attr("for").match(/\d+$/)[0]);
	updateCharges(false, id);
}


function triggerInstrumentChanged(id,closePrice,boardLot)
{
	var exchange = window.result.exchange;
	var product = window.result.series;
	product = (product =='FO') ? window.result.instrument : product;
	var selectedInstrument = window.instrumentDetails[window.result.exchangeToken];

	var contractUnit = 1;
	var lotSize = 1;
	var price = null;

	jQuery("[dataid=lotSizeHelper_" + id +"]").hide();


	if(product.toLowerCase() == "EQ".toLowerCase())
	{
		price = closePrice;
	}
	else
	{
		if(exchange.toLowerCase() == "NSE".toLowerCase())
		{
			// NSE F&O
			price = closePrice;
			lotSize = boardLot;
			jQuery("[dataid=lotSizeHelper_" + id +"]").html("Lot Size: " + lotSize);
			jQuery("[dataid=lotSizeHelper_" + id +"]").show();
		}
		else if(exchange.toLowerCase() == "MCX".toLowerCase())
		{
			price = closePrice;
			contractUnit = boardLot * ((selectedInstrument.gn/selectedInstrument.gd) * (selectedInstrument.pn/selectedInstrument.pd));
			jQuery("[dataid=lotSizeHelper_" + id +"]").hide();
		}
		else
		{
			price = closePrice;
			contractUnit = boardLot * 1000;
			jQuery("[dataid=lotSizeHelper_" + id +"]").hide();
		}

		transactionMap_[id][CONTRACT_UNIT_SIZE_COL] = contractUnit;
	}
	if(price != null && price != "")
	{
		jQuery("[dataid=buyPrice_" + id +"]").val(parseFloat(price).toFixed(2)).addClass("pricetext");
		jQuery("[dataid=sellPrice_" + id +"]").val(Math.round(price * 1.01).toFixed(2)).addClass("pricetext");
	}
	else
	{
		jQuery("[dataid=buyPrice_" + id +"]").val("").removeClass("pricetext");
		jQuery("[dataid=sellPrice_" + id +"]").val("").removeClass("pricetext");
	}
	var qty = parseInt(jQuery("[dataid=qty_" + id +"]").val(), 10);
	if(isNaN(qty))
	qty = 1;
	jQuery("[dataid=qty_" + id +"]").val(qty);
	var defaultScrip = false;
	updateCharges(defaultScrip, id);
}

function addBox(boxId){
	var box = document.getElementById(boxId);
	var secondToLastNode = box.childNodes[box.childNodes.length-1];
	return addBoxInternal(box, secondToLastNode);
}

var count = 0;
function addBoxInternal(box, prevNode)
{
	count++;
	var defaultScrip = false;
	if(jQuery(document).outerWidth() > 992)
		jQuery(".summaryrow").show();

	if(box.childNodes.length > MAX_TABLE_LENGTH)
		return;

	var d = new Date();
	var uniqId = "-"+d.getTime();

	var newNode = box.childNodes[1].cloneNode(true);
	var cInputs = newNode.getElementsByTagName('input');
	var i;
	for(i=0;i<cInputs.length;i++)
	{
		cInputs[i].attributes.dataid.value = cInputs[i].attributes.dataid.value.substring(0, cInputs[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
		if(cInputs[i].type == "text"){
			cInputs[i].value="";
		}
		if(cInputs[i].type == "radio"){
			cInputs[i].name='radio-group_'+count;
			cInputs[i].id = cInputs[i].id.substring(0, cInputs[i].id.indexOf("_")) + "_" + uniqId;
		}

	}

	var radioLabel = newNode.getElementsByTagName('label');
	for(i=0;i<radioLabel.length;i++)
	{
		radioLabel[i].htmlFor = radioLabel[i].htmlFor.substring(0, radioLabel[i].htmlFor.indexOf("_")) + "_" + uniqId;
	}


	var cSelects = newNode.getElementsByTagName('select');
	for(i=0;i<cSelects.length;i++)
	{
		cSelects[i].style.display = '';
		cSelects[i].attributes.dataid.value = cSelects[i].attributes.dataid.value.substring(0, cSelects[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
	}

	var cSpan = newNode.querySelectorAll('span[dataid]');
	for(i=0;i<cSpan.length;i++)
	{
		cSpan[i].attributes.dataid.value = cSpan[i].attributes.dataid.value.substring(0, cSpan[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
	}

	var cDiv = newNode.querySelectorAll('div[dataid]');
	var divsToRemove = [];
	for(i=0;i<cDiv.length;i++)
	{
		if(cDiv[i].attributes.dataid.value.toString().indexOf("lotSizeHelper") > -1)
		{
			cDiv[i].style.display = '';
		}
		if(cDiv[i].className.toString().indexOf("chosen-container") > -1)
			divsToRemove.push(cDiv[i]);
		else{
			cDiv[i].attributes.dataid.value = cDiv[i].attributes.dataid.value.substring(0, cDiv[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
		}
	}
	newNode.attributes.dataid.value = newNode.attributes.dataid.value.substring(0, newNode.attributes.dataid.value.indexOf("_")) + "_" + uniqId;

	for(i=0;i<divsToRemove.length;i++)
	{
		divsToRemove[i].parentElement.removeChild(divsToRemove[i]);
	}
	var cI = newNode.getElementsByTagName('i');
	for(i=0;i<cI.length;i++)
	{
		cI[i].attributes.dataid.value = cI[i].attributes.dataid.value.substring(0, cI[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
	}

	var allLabels = newNode.getElementsByTagName("span");
	for (i=0;i<allLabels.length; i++) {
		allLabels[i].attributes.dataid.value = allLabels[i].attributes.dataid.value.substring(0, allLabels[i].attributes.dataid.value.indexOf("_")) + "_" + uniqId;
		allLabels[i].innerHTML = "&#8377;&nbsp; 0.00";
	}

    transactionMap_[uniqId] = clone(emptyTransaction_);

    arraySize_++;
    var p = box.insertBefore(newNode, prevNode.nextSibling);
    // jQuery("#exchange_" + uniqId).unbind("change");
    // jQuery("#product_" + uniqId).unbind("change");
    // jQuery("#instrument_" + uniqId).unbind("change");

    jQuery("[dataid=searchbox_" +uniqId+ "]").html(window.compiledSearchbox).focus();
    jQuery("[dataid=box-close_" +uniqId+ "]").show();

    jQuery("[dataid=buyPrice_" + uniqId +"]").unbind("keyup");
    jQuery("[dataid=sellPrice_" + uniqId +"]").unbind("keyup");
    jQuery("[dataid=qty_" + uniqId +"]").unbind("keyup");

	jQuery("[dataid=buyPrice_" + uniqId +"]").keyup(function() {
		extractNumber(jQuery("[dataid=buyPrice_" + uniqId +"]")[0]);
		updateCharges(defaultScrip, uniqId);
	});
	jQuery("[dataid=sellPrice_" + uniqId +"]").keyup(function() {
		extractNumber(jQuery("[dataid=sellPrice_" + uniqId +"]")[0]);
		updateCharges(defaultScrip, uniqId);
	});
	jQuery("[dataid=qty_" + uniqId +"]").keyup(function() {
		extractNumber(jQuery("[dataid=qty_" + uniqId +"]")[0]);
		updateCharges(defaultScrip, uniqId);
	});


    jQuery("[dataid=lotSizeHelper_" + uniqId +"]").hide();
    jQuery("[dataid=qty_" + uniqId +"]").val("1");
    jQuery("[dataid=buyPrice_" + uniqId +"]").attr("placeholder", "");
    jQuery("[dataid=sellPrice_" + uniqId +"]").attr("placeholder", "");

    loadScripDetails(uniqId);

    return p;
}

function Round(Number, DecimalPlaces) {
	return Math.round(parseFloat(Number) * Math.pow(10, DecimalPlaces)) / Math.pow(10, DecimalPlaces);
}

function roundFixed(Number, DecimalPlaces) {
	return Round(Number, DecimalPlaces).toFixed(DecimalPlaces);
}

function updateCharges(defaultScrip, id)
{
	extractNumberById(id);
	updateChargesById(defaultScrip,id);
}

function updateChargesById(defaultScrip, id)
{
	var oldTransactionCharges = transactionMap_[id];
	var newTransactionCharges = clone(emptyTransaction_);
	newTransactionCharges[CONTRACT_UNIT_SIZE_COL] = oldTransactionCharges[CONTRACT_UNIT_SIZE_COL];
	var exchange = window.result.exchange;
	if(exchange == 'BSE'){
		var product = window.result.series;
	}else{
		var product = window.result.instrument;
	}
	

	var qty = parseInt(jQuery("[dataid=qty_" + id +"]").val(), 10);
	var buyPrice = parseFloat(jQuery("[dataid=buyPrice_" + id +"]").val());
	var sellPrice = parseFloat(jQuery("[dataid=sellPrice_" + id +"]").val()) || 0;

    var buyBackBEP = 0;
	var sellBackBEP = 0;
	var i;

    if(isNaN(qty) || (isNaN(buyPrice) && isNaN(sellPrice)) || qty == 0 || (buyPrice == 0 && sellPrice == 0))
    {
		// go up to length - 1 because the last column holds static information
		for(i=0; i<newTransactionCharges.length; i++)
		{
			if(i == 14)
				newTransactionCharges[i] = 1;
			else
				newTransactionCharges[i] = 0;
		}
    }

    if(isNaN(qty))
    {
    	qty = 0;
    }
    if(isNaN(buyPrice))
    {
    	buyPrice = 0;
    }
    if(isNaN(sellPrice))
    {
    	sellPrice = 0;
    }
	var aQty = qty;

	aQty = aQty * newTransactionCharges[CONTRACT_UNIT_SIZE_COL];

	if (exchange === EXCHANGE_NSECDS || exchange === EXCHANGE_BSECDS) {
		aQty = aQty * 1000;
	}

	var buyTurnover = buyPrice * aQty;
	var sellTurnover = sellPrice * aQty;
	if(isNaN(buyTurnover))
		buyTurnover = 0;
	if(isNaN(sellTurnover))
		sellTurnover = 0;
	newTransactionCharges[BUY_TURNOVER_COL] = buyTurnover;
	newTransactionCharges[SELL_TURNOVER_COL] = sellTurnover;
	var buyBrokerage = 0;
	var sellBrokerage = 0;
	var currTurnover = Round((buyPrice + sellPrice) * aQty, 2);
	var currSTTRate, currTurnoverChargeRate, currStampDutyRate = 0;
	var currSebiRate = SEBI_RATE;

	var STTDeliveryAddOnFactor=1;
	switch(exchange)
	{
		case EXCHANGE_BSE:
			switch(product)
			{
				case PRODUCT_EQ:
					if(intraday)
					{
						currSTTRate = STT_INTRADAY;
						currTurnoverChargeRate = TURNOVER_BSE_EQ;
						if(buyTurnover != 0)
						{
							buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
							newTransactionCharges[BKG_COL] += buyBrokerage;
							currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_EQ_INTR_INDEX];
						}
						if(sellTurnover != 0)
						{
							sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
							newTransactionCharges[BKG_COL] += sellBrokerage;
						}
					}
					else
					{
						currSTTRate = STT_DELIVERY;
						currTurnoverChargeRate = TURNOVER_BSE_EQ;
						if(buyTurnover != 0)
						{
							if(buyPrice >= 10){		
								buyBrokerage = Math.min(MAX_BROKERAGE, BKG_DELIVERY * buyTurnover);
								newTransactionCharges[BKG_COL] += buyBrokerage;
								currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_EQ_DEL_INDEX];
														
							}else{
								PennyBrokerageFinal = Math.min(aQty * Penny_Brokerage);	
								if(PennyBrokerageFinal>=20){
									newTransactionCharges[BKG_COL] += 20;	
								}else{
									newTransactionCharges[BKG_COL] += Math.min(aQty * Penny_Brokerage);	
								}
							}
						}
						if(sellTurnover != 0)
						{
							if(sellPrice >= 10){		
								sellBrokerage = Math.min(MAX_BROKERAGE, BKG_DELIVERY * sellTurnover);
								newTransactionCharges[BKG_COL] += sellBrokerage;
														
							}else{
								PennyBrokerageFinal = Math.min(aQty * Penny_Brokerage);	
								if(PennyBrokerageFinal>=20){
									newTransactionCharges[BKG_COL] += 20;	
								}else{
									newTransactionCharges[BKG_COL] += Math.min(aQty * Penny_Brokerage);	
								}
							}
						}
						STTDeliveryAddOnFactor = 2;
					}
				break;
			}
		break;
		case EXCHANGE_NSE:
			switch(product)
			{
				case PRODUCT_EQ:
					if(intraday)
					{
						currSTTRate = STT_INTRADAY;
						currTurnoverChargeRate = TURNOVER_NSE_EQ;
						if(buyTurnover != 0)
						{
							buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
							newTransactionCharges[BKG_COL] += buyBrokerage;
							currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_EQ_INTR_INDEX];
						}
						if(sellTurnover != 0)
						{
							sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
							newTransactionCharges[BKG_COL] += sellBrokerage;
						}
					}
					else
					{
						currSTTRate = STT_DELIVERY;
						currTurnoverChargeRate = TURNOVER_NSE_EQ;
						if(buyTurnover != 0)
						{
							
							if(buyPrice >= 10){		
								buyBrokerage = Math.min(MAX_BROKERAGE, BKG_DELIVERY * buyTurnover);
								newTransactionCharges[BKG_COL] += buyBrokerage;
								currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_EQ_DEL_INDEX];
														
							}else{
								PennyBrokerageFinal = Math.min(aQty * Penny_Brokerage);	
								if(PennyBrokerageFinal>=20){
									newTransactionCharges[BKG_COL] += 20;	
								}else{
									newTransactionCharges[BKG_COL] += Math.min(aQty * Penny_Brokerage);	
								}
							}
						}
						if(sellTurnover != 0)
						{

							if(sellPrice >= 10){		
								sellBrokerage = Math.min(MAX_BROKERAGE, BKG_DELIVERY * sellTurnover);
								newTransactionCharges[BKG_COL] += sellBrokerage;
														
							}else{
								PennyBrokerageFinal = Math.min(aQty * Penny_Brokerage);	
								if(PennyBrokerageFinal>=20){
									newTransactionCharges[BKG_COL] += 20;	
								}else{
									newTransactionCharges[BKG_COL] += Math.min(aQty * Penny_Brokerage);	
								}
							}
						}
						STTDeliveryAddOnFactor = 2;
					}
				break;
				case PRODUCT_F:
					currSTTRate = STT_FUTURES;
					currTurnoverChargeRate = TURNOVER_NSE_FUT;
					if(buyTurnover != 0)
					{
						if(isNRI)
							buyBrokerage = Math.min(MAX_BROKERAGE_NRI, BKG_FUT_NRI * buyTurnover);
						else
							buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
						newTransactionCharges[BKG_COL] += buyBrokerage;
						
						currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_FUT_INDEX];
					}
					if(sellTurnover != 0)
					{
						if(isNRI)
							sellBrokerage = Math.min(MAX_BROKERAGE_NRI, BKG_FUT_NRI * sellTurnover);
						else
							sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
				case PRODUCT_O:
					currSTTRate = STT_OPTIONS;
					currTurnoverChargeRate = TURNOVER_NSE_OPT;
					if(buyTurnover != 0)
					{
						if(isNRI)
							buyBrokerage = MAX_BROKERAGE_NRI;
						else
							buyBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += buyBrokerage;

						currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_OPT_INDEX];
					}
					if(sellTurnover != 0)
					{
						if(isNRI)
							sellBrokerage = MAX_BROKERAGE_NRI;
						else
							sellBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
			}
		break;
		case EXCHANGE_NSECDS:
			switch(product)
			{
				case PRODUCT_F:
					currSTTRate = 0;
					currTurnoverChargeRate = TURNOVER_NSE_CURR_FUT;
					currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_CDS_INDEX];
					if(buyTurnover != 0)
					{
						buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
						newTransactionCharges[BKG_COL] += buyBrokerage;
					}
					if(sellTurnover != 0)
					{
						sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
				case PRODUCT_O:
					currSTTRate = 0;
					currTurnoverChargeRate = TURNOVER_NSE_CURR_OPT;
					currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_CDS_INDEX];
					if(buyTurnover != 0)
					{
						buyBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += buyBrokerage;
					}
					if(sellTurnover != 0)
					{
						sellBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
			}
		break;
		case EXCHANGE_BSECDS:
			switch(product)
			{
				case PRODUCT_F:
					currSTTRate = 0;
					currTurnoverChargeRate = TURNOVER_BSE_CURR_FUT;
					currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_CDS_INDEX];
					if(buyTurnover != 0)
					{
						buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
						newTransactionCharges[BKG_COL] += buyBrokerage;
					}
					if(sellTurnover != 0)
					{
						sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
				case PRODUCT_O:
					currSTTRate = 0;
					currTurnoverChargeRate = TURNOVER_BSE_CURR_OPT;
					currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_CDS_INDEX];
					if(buyTurnover != 0)
					{
						buyBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += buyBrokerage;
					}
					if(sellTurnover != 0)
					{
						sellBrokerage = MAX_BROKERAGE;
						newTransactionCharges[BKG_COL] += sellBrokerage;
					}
				break;
			}
		break;
		case EXCHANGE_MCX:
			currTurnoverChargeRate = TURNOVER_MCX_FUT;
			currSTTRate = CTT_INTRADAY;
			currStampDutyRate = SELECTED_STAMP_DUTY_RATE[STAMP_DUTY_COMMO_INDEX];
			if (product === PRODUCT_O) {
				currStampDutyRate = STAMP_DUTY_COMMO_INDEX_OPT;
			}
			if(buyTurnover != 0)
			{
				buyBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * buyTurnover);
				newTransactionCharges[BKG_COL] += buyBrokerage;
			}
			if(sellTurnover != 0)
			{
				sellBrokerage = Math.min(MAX_BROKERAGE, BKG_INTRADAY * sellTurnover);
				newTransactionCharges[BKG_COL] += sellBrokerage;
			}
		break;
	}

	if( (exchange == EXCHANGE_NSE || exchange == EXCHANGE_BSE) && product == PRODUCT_EQ && !intraday)
		newTransactionCharges[STT_COL] = currTurnover * currSTTRate;
	else
		newTransactionCharges[STT_COL] = sellTurnover * currSTTRate;


	newTransactionCharges[TXN_COL] = currTurnover * currTurnoverChargeRate;

	DP_CHARGES = (product == PRODUCT_EQ && !intraday && sellPrice > 0) ? 20 : 0;
	
	newTransactionCharges[SVC_TAX_COL] = SVC_TAX_RATE * (newTransactionCharges[TXN_COL] + buyBrokerage + sellBrokerage + DP_CHARGES);

	newTransactionCharges[EDU_CESS_COL] = EDU_CESS_RATE * (newTransactionCharges[SVC_TAX_COL]);

	newTransactionCharges[H_EDU_CESS_COL] = HIGHER_EDU_CESS_RATE * (newTransactionCharges[SVC_TAX_COL]);

	newTransactionCharges[STAMP_DUTY_COL] = currStampDutyRate *  Round((buyPrice) * aQty, 2); // stamp duty is only on buy side

	newTransactionCharges[SEBI_FEES_COL] = currSebiRate * currTurnover;
	newTransactionCharges[SVC_TAX_COL] += newTransactionCharges[SEBI_FEES_COL] * SVC_TAX_RATE;

	newTransactionCharges[CURR_TURNOVER_COL] = currTurnover;

	if(buyPrice == 0  || sellPrice == 0)
		newTransactionCharges[MTM_COL] = 0;
	else
		newTransactionCharges[MTM_COL] = (sellPrice - buyPrice) * aQty - newTransactionCharges[BKG_COL] - newTransactionCharges[STT_COL]
	- newTransactionCharges[TXN_COL] - newTransactionCharges[SVC_TAX_COL] - newTransactionCharges[EDU_CESS_COL]
	- newTransactionCharges[H_EDU_CESS_COL] - newTransactionCharges[STAMP_DUTY_COL] - newTransactionCharges[SEBI_FEES_COL];
	var commission = currTurnoverChargeRate + SVC_TAX_RATE*currTurnoverChargeRate
	+ (EDU_CESS_RATE+HIGHER_EDU_CESS_RATE)*SVC_TAX_RATE*currTurnoverChargeRate + currStampDutyRate
	+ currSebiRate;
	if(buyPrice != 0)
	{
		sellBackBEP = ((buyPrice * aQty) * (1 + commission)) + buyBrokerage * 2 *(1 + SVC_TAX_RATE + SVC_TAX_RATE*EDU_CESS_RATE + SVC_TAX_RATE*HIGHER_EDU_CESS_RATE);
		sellBackBEP /= (aQty * (1 - currSTTRate*STTDeliveryAddOnFactor - commission));
		if(exchange == EXCHANGE_NSECDS || exchange == EXCHANGE_BSECDS)
			sellBackBEP = Math.ceil(sellBackBEP*10000)/10000;
		else
			sellBackBEP = Math.ceil(sellBackBEP*100)/100;
	}
	if(sellPrice != 0)
	{
		buyBackBEP = (sellPrice * aQty)*(1 - currSTTRate*STTDeliveryAddOnFactor - commission) - sellBrokerage*2;
		buyBackBEP /= (aQty * (1 + commission));

		if(exchange == EXCHANGE_NSECDS || exchange == EXCHANGE_BSECDS)
			buyBackBEP = Math.floor(buyBackBEP*10000)/10000;
		else
			buyBackBEP = Math.floor(buyBackBEP*100)/100;
	}

	if( ( (exchange == EXCHANGE_NSE || exchange == EXCHANGE_BSE ) && product == PRODUCT_EQ) || (exchange == EXCHANGE_MCX && product == PRODUCT_O )){
		newTransactionCharges[CLR_CHG_COL] = 0.00;
	}
	else if( exchange == EXCHANGE_NSE ){
		if(product == PRODUCT_F){
			newTransactionCharges[CLR_CHG_COL] = 0.0000020 * currTurnover;
		}
		else if(product == PRODUCT_O ){
			newTransactionCharges[CLR_CHG_COL] = 0.0000500 * currTurnover;
		}
	}
	else if(exchange == EXCHANGE_NSECDS || exchange == EXCHANGE_BSECDS){
		if(product == PRODUCT_F){
			newTransactionCharges[CLR_CHG_COL] = 0.0000040 * currTurnover;
		}
		else if(product == PRODUCT_O ){
			newTransactionCharges[CLR_CHG_COL] = 0.0002000 * currTurnover;
		}

	}
	else if(exchange == EXCHANGE_MCX){
		if(product == PRODUCT_F){
			newTransactionCharges[CLR_CHG_COL] = 0.0000050 * currTurnover;
		}
	}

	newTransactionCharges[CLR_CHG_COL] = 0.00;

	var totalTransactionCharges = 0;

	for(i=0; i<newTransactionCharges.length; i++)
	{
		if(isNaN(newTransactionCharges[i])){
			newTransactionCharges[i] = 0.00 , totalTransactionCharges_[i] = 0.00;
		}

		if(defaultScrip === true){
			totalTransactionCharges_[i] = newTransactionCharges[i] - oldTransactionCharges[i];
		}
		else{
			totalTransactionCharges_[i] = Number(parseFloat(totalTransactionCharges_[i] + newTransactionCharges[i] - oldTransactionCharges[i]).toFixed(5));
		}

		if(i!=CURR_TURNOVER_COL && i!=MTM_COL && i!=BKG_COL)
			totalTransactionCharges += totalTransactionCharges_[i];
	}

	transactionMap_[id] = newTransactionCharges;

	var maxVal = 0.01;
	var decPlaces = 2;
	if(exchange == EXCHANGE_NSECDS || exchange == EXCHANGE_BSECDS)
	{
		maxVal = 0.0001;
		decPlaces = 4;
	}

	updateTotals(totalTransactionCharges,id);

}

function updateTotals(totalTransactionCharges,id)
{
	totalTransactionCharges = parseFloat(0);

	for(var i=0; i<totalTransactionCharges_.length; i++)
	{
		if( i!=MTM_COL && i!=CURR_TURNOVER_COL && i!=BUY_TURNOVER_COL && i!=SELL_TURNOVER_COL && i!=CONTRACT_UNIT_SIZE_COL && i!=STRIKE_PX_COL)
			totalTransactionCharges = totalTransactionCharges + parseFloat(roundFixed(totalTransactionCharges_[i], 2));
	}
	totalTransactionCharges += DP_CHARGES;

	const qty = parseInt(jQuery("[dataid=qty_" + id +"]").val(), 10) || 0;

	jQuery("[dataid=lblBrokerage_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[BKG_COL], 2)) + "</span>");
	jQuery("[dataid=lblSTT_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[STT_COL], 2)) + "</span>");
	jQuery("[dataid=lblTurnoverCharges_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[TXN_COL], 2)) + "</span>");
	jQuery("[dataid=lblClearingCharges_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[CLR_CHG_COL], 2)) + "</span>");
	jQuery("[dataid=dpCharges_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(DP_CHARGES, 2)) + "</span>");
	jQuery("[dataid=lblServiceTax_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[SVC_TAX_COL], 2)) + "</span>");
	//jQuery("#lblEduCess").html("&#8377;&nbsp;" + addCommas(roundFixed(totalTransactionCharges_[EDU_CESS_COL], 2)));
	//jQuery("#lblHigherEduCess").html("&#8377;&nbsp;" + addCommas(roundFixed(totalTransactionCharges_[H_EDU_CESS_COL], 2)));
	jQuery("[dataid=lblStampDuty_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[STAMP_DUTY_COL], 2)) + "</span>");
	jQuery("[dataid=lblSEBITurnover_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[SEBI_FEES_COL], 2)) + "</span>");
	jQuery("[dataid=lblTotalTransactionCharges_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges, 2)) + "</span>");
	jQuery("[dataid=lblTotalTurnover"+"]").html("&#8377;&nbsp;<span>" + toPrettyNumber(totalTransactionCharges_[CURR_TURNOVER_COL], 2) + "</span>");
	jQuery("[dataid=lblTotalPnL_"+id+"]").html("&#8377;&nbsp;<span>" + toPrettyNumber(totalTransactionCharges_[MTM_COL], 2) + "</span>");
	jQuery("[dataid=lbltaxes_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(Math.abs(parseFloat(totalTransactionCharges - totalTransactionCharges_[BKG_COL]).toFixed(2)))+ "</span>");

	jQuery("[dataid=lblNetSellValue_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[SELL_TURNOVER_COL], 2)) + "</span>");
	jQuery("[dataid=lblNetBuyValue_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[BUY_TURNOVER_COL], 2)) + "</span>");
	jQuery("[dataid=lblGrossPnL_"+id+"]").html("&#8377;&nbsp;<span>" + addCommas(roundFixed(totalTransactionCharges_[SELL_TURNOVER_COL] - totalTransactionCharges_[BUY_TURNOVER_COL], 2)) + "</span>");
	const isCurrency = window.result && (window.result.exchange === EXCHANGE_NSECDS || window.result.exchange === EXCHANGE_BSECDS);
	let totalBreakeven = toPrettyNumber((totalTransactionCharges / qty), 2);
	if (isCurrency) {
		totalBreakeven = toPrettyNumber((parseFloat(totalBreakeven) / 1000), 4) ;
	}
	jQuery("[dataid=breakeven_" + id +"]").html("&#8377;&nbsp;<span>" + totalBreakeven + "</span>");
	jQuery("[dataid=pnl_" + id +"]").html("&#8377;&nbsp;<span>" + toPrettyNumber(totalTransactionCharges_[SELL_TURNOVER_COL] - totalTransactionCharges_[BUY_TURNOVER_COL] - totalTransactionCharges, 2) + "</span>");

	updateFooter();
}
function toPrettyNumber(number, places)
{
	if(isNaN(number))
		return "0.00";

	var absNumber = Math.abs(number);

	if(absNumber >= LAKH && absNumber < CRORE)
	{
		return roundFixed(number/LAKH, places) + " lakh";
	}
	else if (absNumber >= CRORE)
	{
		return roundFixed(number/CRORE, places) + " cr";
	}
	else
		return addCommas(roundFixed(number, places));
}

function removeById(containerID, id)
{
	var rowCount = jQuery(".bk-cal-box").length;

	document.querySelectorAll("[dataid=qty_" + id + "]").value = 0;

	jQuery('[dataid=bkCalBox_'+id+']').slideUp(500, function() {
	    jQuery(this).remove();
	});

	arraySize_--;

	delete transactionMap_[id];

	if(rowCount == 2 && jQuery(document).outerWidth() > 992){
		jQuery(".summaryrow").hide();
        jQuery('.brokerage-calculator-table-section').css('padding-bottom','0');
	}
	if(window.result){
		updateChargesById(defaultScrip, id);
	}

	adjustFooter();
}

function removeBox(containerID, who)
{
	var dataid = who.attributes.dataid.value;
	var subId = dataid.substring(dataid.indexOf("_") + 1, dataid.length);
	removeById(containerID, subId);
}
function addCommas(number)
{
	number += '';
	var x = number.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

function extractNumberById(id)
{
	extractNumber(jQuery("[dataid=buyPrice_" + id +"]")[0]);
	extractNumber(jQuery("[dataid=sellPrice_" + id +"]")[0]);
}

function extractNumber(obj)
{
	var name = obj.attributes.dataid.value;
	var decimalPlaces = 0;
	var allowNegative = false;
	if (name.substring(0,3) != "qty")
	{
		var exchange = window.result.exchange;
		// if(name.indexOf('_') != -1)
		// {
		// 	// exchange = jQuery("#exchange_" + id).val();
		// 	exchange = window.result.series;
		// }

		if(exchange == EXCHANGE_NSECDS || exchange == EXCHANGE_BSECDS)
			decimalPlaces = 4;
		else
			decimalPlaces = 2;
	}

	var temp = obj.value;

	// avoid changing things if already formatted correctly
	var reg0Str = '[0-9]*';
	if (decimalPlaces > 0) {
		reg0Str += '\\.?[0-9]{0,' + decimalPlaces + '}';
	} else if (decimalPlaces < 0) {
		reg0Str += '\\.?[0-9]*';
	}
	reg0Str = allowNegative ? '^-?' + reg0Str : '^' + reg0Str;
	reg0Str = reg0Str + '$';
	var reg0 = new RegExp(reg0Str);
	if (reg0.test(temp)) return true;

	// first replace all non numbers
	var reg1Str = '[^0-9' + (decimalPlaces != 0 ? '.' : '') + (allowNegative ? '-' : '') + ']';
	var reg1 = new RegExp(reg1Str, 'g');
	temp = temp.replace(reg1, '');

	if (allowNegative) {
		// replace extra negative
		var hasNegative = temp.length > 0 && temp.charAt(0) == '-';
		var reg2 = /-/g;
		temp = temp.replace(reg2, '');
		if (hasNegative) temp = '-' + temp;
	}

	if (decimalPlaces != 0) {
		var reg3 = /\./g;
		var reg3Array = reg3.exec(temp);
		if (reg3Array != null) {
			// keep only first occurrence of .
			//  and the number of places specified by decimalPlaces or the entire string if decimalPlaces < 0
			var reg3Right = temp.substring(reg3Array.index + reg3Array[0].length);
			reg3Right = reg3Right.replace(reg3, '');
			reg3Right = decimalPlaces > 0 ? reg3Right.substring(0, decimalPlaces) : reg3Right;
			temp = temp.substring(0,reg3Array.index) + '.' + reg3Right;
		}
	}

	obj.value = temp;
}

function blockNonNumbers(obj, e, allowDecimal, allowNegative)
{
	var key;
	var isCtrl = false;
	var keychar;
	var reg;

	if(window.event) {
		key = e.keyCode;
		isCtrl = window.event.ctrlKey
	}
	else if(e.which) {
		key = e.which;
		isCtrl = e.ctrlKey;
	}

	if (isNaN(key)) return true;

	keychar = String.fromCharCode(key);

	// check for backspace or delete, or if Ctrl was pressed
	if (key == 8 || isCtrl)
	{
		return true;
	}

	reg = /\d/;
	var isFirstN = allowNegative ? keychar == '-' && obj.value.indexOf('-') == -1 : false;
	var isFirstD = allowDecimal ? keychar == '.' && obj.value.indexOf('.') == -1 : false;
	return isFirstN || isFirstD || reg.test(keychar);
}

function toggleLayer(whichLayer)
{
	var style2;
	if (document.getElementById)
	{
          // this is the way the standards work
          style2 = document.getElementById(whichLayer).style;
          style2.display = style2.display? "":"block";
      }
      else if (document.all)
      {
          // this is the way old msie versions work
          style2 = document.all[whichLayer].style;
          style2.display = style2.display? "":"block";
      }
      else if (document.layers)
      {
          // this is the way nn4 works
          style2 = document.layers[whichLayer].style;
          style2.display = style2.display? "":"block";
      }
  }
  function clone(obj) {
    // Handle the 3 simple types, and null or undefined
	if (null == obj || "object" != typeof obj) return obj;

	var copy;

    // Handle Date
    if (obj instanceof Date) {
    	copy = new Date();
    	copy.setTime(obj.getTime());
    	return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
    	copy = [];
    	var len = obj.length;
    	for (var i = 0; i < len; ++i) {
    		copy[i] = clone(obj[i]);
    	}
    	return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
    	copy = {};
    	for (var attr in obj) {
    		if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
    	}
    	return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}
function updatePrices(uniqId, closePrice){
    if(closePrice != null && closePrice != "")
    {
        jQuery("[dataid=buyPrice_"+uniqId+"]").val(parseFloat(closePrice).toFixed(2)).addClass("pricetext");
        jQuery("[dataid=sellPrice_"+uniqId+"]").val(Math.round(closePrice * 1.01).toFixed(2)).addClass("pricetext");
    }
    else
    {
        jQuery("[dataid=buyPrice_"+uniqId+"]").val("").removeClass("pricetext");
        jQuery("[dataid=sellPrice_"+uniqId+"]").val("").removeClass("pricetext");
    }
}

function updateFooter(){
	var bkgVal=0.00, totalTaxesVal=0.00, totalPnlVal=0.00;

	jQuery('.lblBkg span').each(function(){
		bkgVal += parseFloat(jQuery(this).text());
	})

	jQuery('.lblTotalTransactionCharges span').each(function(){
		totalTaxesVal += parseFloat(jQuery(this).text());
	})

	jQuery('.lblTotalNetPnl span').each(function(){
		var tempPnlVal = parseFloat(jQuery(this).text().replace(/\,/g,""));
		totalPnlVal += tempPnlVal;
	});

	jQuery("#lblFooterBrokerage").html("&#8377;&nbsp;<span>" + bkgVal.toFixed(2) + "</span>");
	jQuery("#lblFooterSTT").html("&#8377;&nbsp;<span>" + totalTaxesVal.toFixed(2) + "</span>");
	jQuery("#lblFooterPnl").html("&#8377;&nbsp;<span>" + addCommas(totalPnlVal.toFixed(2)) + "</span>");
}

function updateContractNote(){

    var modalTableObj = []
    var tr;
    var breakevenVal = 0.00, turnoverVal = 0.00, servicetaxVal = 0.00, stampdutyVal = 0.00,
    sebiturnoverVal = 0.00, netbuyVal = 0.00, netsellVal = 0.00, totalSttVal = 0.00, netClearingCharge = 0.00, netDpCharges = 0.00;

    jQuery('[dataid=search1]').each(function(i) {
        var obj = {}
        obj['scrip'] = jQuery(this).val()
        modalTableObj.push(obj);
    });

    jQuery('[dataid^=qty_]').each(function(i) {
        modalTableObj[i]['qty'] = jQuery(this).val()
    });

    jQuery('[dataid^=buyPrice_]').each(function(i) {
        modalTableObj[i]['buyprice'] = "&#8377;&nbsp;" +jQuery(this).val()
    });

    jQuery('[dataid^=sellPrice_]').each(function(i) {
        modalTableObj[i]['sellprice'] = "&#8377;&nbsp;" +jQuery(this).val()
    });

    jQuery('[dataid^=intraday_]:checked,[dataid^=delivery_]:checked').each(function(i) {
        modalTableObj[i]['position'] = jQuery(this).val()
    });

    jQuery(modalTableObj).each(function(index) {
    	if(modalTableObj[index].scrip != "" && modalTableObj[index].buyprice != ""){
    		tr += "<tr>";
	        jQuery.each(modalTableObj[index], function(key, value) {
	            tr += "<td>" + value + "</td>";
	        });
	        tr +="</tr>";
    	}

    });

    jQuery("#modalTable tbody").html(tr);

    jQuery("[dataid^=breakeven_].totalval span").each(function(){
    	breakevenVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblTurnoverCharges_] span').each(function() {
        turnoverVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblServiceTax_] span').each(function() {
        servicetaxVal += parseFloat(jQuery(this).text());
    });

    jQuery("[dataid^=lblSTT_] span").each(function(){
    	totalSttVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblClearingCharges_] span').each(function() {
        netClearingCharge += parseFloat(jQuery(this).text());
    });

	jQuery('[dataid^=dpCharges_] span').each(function() {
        netDpCharges += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblStampDuty_] span').each(function() {
        stampdutyVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblSEBITurnover_] span').each(function() {
        sebiturnoverVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblNetBuyValue_] span').each(function() {
        netbuyVal += parseFloat(jQuery(this).text());
    });

    jQuery('[dataid^=lblNetSellValue_] span').each(function() {
        netsellVal += parseFloat(jQuery(this).text());
    });

    jQuery("[dataid=modalBrokerage]").html(jQuery("#lblFooterBrokerage").html());
    jQuery("[dataid=modalBreakeven]").html("&#8377;&nbsp;" +breakevenVal.toFixed(2));
    jQuery("[dataid=modalPnl]").html(jQuery("#lblFooterPnl").html());

    jQuery("[dataid=modalTurnoverCharges]").html("&#8377;&nbsp;" +turnoverVal.toFixed(2));
    jQuery("[dataid=modalSTT]").html("&#8377;&nbsp;" +totalSttVal.toFixed(2));
    jQuery("[dataid=modalServiceTax]").html("&#8377;&nbsp;" +servicetaxVal.toFixed(2));
    jQuery("[dataid=modalClearingCharges]").html("&#8377;&nbsp;" +netClearingCharge.toFixed(2));
	jQuery("[dataid=modalDpCharges]").html("&#8377;&nbsp;" +netDpCharges.toFixed(2))
	jQuery("[dataid=modalStampDuty]").html("&#8377;&nbsp;" +stampdutyVal.toFixed(2));
    jQuery("[dataid=modalSEBITurnover]").html("&#8377;&nbsp;" +sebiturnoverVal.toFixed(2));
    jQuery("[dataid=modalNetBuyValue]").html("&#8377;&nbsp;" +netbuyVal.toFixed(2));
    jQuery("[dataid=modalNetSellValue]").html("&#8377;&nbsp;" +netsellVal.toFixed(2));

}

function adjustFooter(){
	if(jQuery(document).outerWidth() > 992){
		if((jQuery(window).scrollTop() + jQuery(window).height()) >= jQuery('footer').offset().top && jQuery('.summaryrow').is(":visible")){
	        
	        jQuery('.summaryrow').css({
	            'position' : 'absolute',
	            'bottom': jQuery('footer').height()+ 92 +"px"  ,
	            'top' :'initial'
	        });
	        jQuery('.brokerage-calculator-table-section').css({
	            'padding-bottom':'135px'
	        });
	    }
	    else{
	        jQuery('.summaryrow').css({
	            'position': 'fixed',
	            'bottom': '92px',
	            'top' : 'initial'
	        });
	        jQuery('.brokerage-calculator-table-section').css('padding-bottom','135px');
	    }
	}

}

function loadScripDetails(id){
    window.default = 1;
    var exchangeToken = window.result.exchangeToken;

    jQuery.getJSON("https://bom1.upstox.com/v0/instruments/details?tokens="+exchangeToken, function(json){
        window.instrumentDetails = json;
        window.result.symbol = window.instrumentDetails[exchangeToken].symbol;
        window.result.instrument = window.instrumentDetails[exchangeToken].status;
        var closePrice = window.instrumentDetails[exchangeToken].cp;
        updatePrices(id, closePrice);
        updateCharges(true, id);
        jQuery("[dataid=searchbox_"+id+"] [dataid=search1]").val(window.result.exchange+' '+window.result.symbol+' '+window.result.series);
    });
}
window.loadScripDetails = loadScripDetails
window.adjustFooter = adjustFooter


